var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'mx-auto p-'+_vm.padding+' relative'},[_c('v-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }